import React, { Suspense } from 'react';
import { ComponentConfig, FieldLabel } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../../page-builder/puck/reusable-props/NewMargin';
import PostUpSellDeal from './PostUpsellDeal';
import { useCallback, useEffect } from 'react';
import {
  ISelectedUpsellItems,
  postUpsellPurchasePayload,
} from '../../../../page-builder/interface/postUpsellInterface';
import {
  ErrorResponse,
  useNavigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import checkoutService from '../../../api/checkoutService';
import {
  setErrorStatus,
  setIsLoading,
  setSelectedVariant,
} from '../../../../page-builder/redux/slices/postUpsellStateSlice';
import { Switch, Tooltip } from '@mui/material';
import {
  paddingFields,
  PaddingProps,
  PaddingType,
} from '../../../../page-builder/puck/reusable-props/padding';
import {
  ReduxSelectorProps,
  ReduxDispatchProps,
} from '../../../services/constants';
import { AxiosInstance } from 'axios';
import CustomTooltip from '../../../../components/common/tooltip';
import {
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../../utils/helper';
import {
  checkAndReturnWithProductVariantIdPrefix,
  getIsViewIsEdit,
  PageType,
} from '../../../utils/constants';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import WidthAndHeight, {
  WidthAndHeightSubProps,
} from '../../../puck/reusable-props/widthAndHeight';
import BackgroungColorComponent from '../../customComponents/BackgroungColorComponent';
import WithAccordion from '../../customComponents/CustomAccordion';
import PaddingComponent from '../../customComponents/PaddingComponent';
import QuilHelper from '../../../puck/reusable-props/quilHelper';
import InfoIcon from '@mui/icons-material/Info';
import GradientPicker from '../../GradientPicker';
import {
  setCurrentUpsellData,
  setSelectedUpsellItems,
} from '../../../redux/slices/postUpsellSlice';
import { showNotification } from '../../../api/constant';

const PostUpsellPayPal = React.lazy(() => import('../PostUpsell-PayPal'));

export type SingleProductAcceptButtonProps = {
  border: IBorderValueProps;
  titleCustomization: {
    content: string;
    bgColorTitle: {
      color: string;
      isInherit: boolean;
    };
    padding: PaddingType;
  };
  offerCustomization: {
    content: string;
    bgColorOffer: {
      color: string;
      isInherit: boolean;
    };
    padding: PaddingType;
  };

  CustamizeButton: {
    widthAndHeight: WidthAndHeightSubProps;
    bgColor: {
      color: string;
      isInherit: boolean;
    };
    hideTitle: boolean;
    hideOffer: boolean;
    gradient: { isGradientChecked: boolean; color: string };
  };
} & MarginProps &
  PaddingProps &
  showComponentProps;

export interface SingleProductAcceptButtonComponentProps
  extends ReduxSelectorProps,
    ReduxDispatchProps {
  baseService?: AxiosInstance;
}
export const SingleProductAcceptButton = ({
  useAppSelector,
  useAppDispatch,
}: SingleProductAcceptButtonComponentProps): ComponentConfig<SingleProductAcceptButtonProps> => {
  return {
    label: (
      <CustomTooltip title="Upsell Deal">
        <span>Single Product Accept Button</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },

      titleCustomization: {
        type: 'custom',
        label: 'Title Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Title Customization">
              <QuilHelper
                value={value.content}
                onChange={val => {
                  onChange({
                    ...value,
                    content: val,
                  });
                }}
                enableLink={true}
                id={1}
              />
              <BackgroungColorComponent
                value={value.bgColorTitle}
                onChange={val => {
                  onChange({
                    ...value,
                    bgColorTitle: val,
                  });
                }}
                title="Background Color"
              />
              <PaddingComponent
                value={value.padding}
                onChange={val => {
                  onChange({
                    ...value,
                    padding: val,
                  });
                }}
                title="Padding"
              />
            </WithAccordion>
          );
        },
      },
      offerCustomization: {
        type: 'custom',
        label: 'Offer Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Offer Customization">
              <QuilHelper
                value={value.content}
                onChange={val => {
                  onChange({
                    ...value,
                    content: val,
                  });
                }}
                enableLink={true}
                id={2}
              />
              <BackgroungColorComponent
                value={value.bgColorOffer}
                onChange={val => {
                  onChange({
                    ...value,
                    bgColorOffer: val,
                  });
                }}
                title="Background Color"
              />
              <PaddingComponent
                value={value.padding}
                onChange={val => {
                  onChange({
                    ...value,
                    padding: val,
                  });
                }}
                title="Padding"
              />
            </WithAccordion>
          );
        },
      },

      CustamizeButton: {
        type: 'custom',
        label: 'Button Customize',
        render: ({ value, onChange }) => {
          return (
            <>
              <WithAccordion title="Button Customize">
                <WidthAndHeight
                  value={value.widthAndHeight}
                  onChange={val => {
                    onChange({
                      ...value,
                      widthAndHeight: val,
                    });
                  }}
                  title={'Custom Button'}
                  isfullWidth={true}
                />
                <BackgroungColorComponent
                  value={value.bgColor}
                  onChange={val => {
                    onChange({
                      ...value,
                      bgColor: val,
                    });
                  }}
                  title="Background Color"
                />
                <WithAccordion title="Gradient Color">
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <p className="text-sm font-semibold">Gradient</p>
                      <div className="flex gap-0.5 items-center">
                        <Tooltip
                          title="Enable to apply a gradient background"
                          placement="top-start">
                          <InfoIcon fontSize="small" className="h-4 w-4" />
                        </Tooltip>
                        <Switch
                          onChange={e =>
                            onChange({
                              ...value,
                              gradient: {
                                ...value?.gradient,
                                isGradientChecked: e.target.checked,
                              },
                            })
                          }
                          checked={value?.gradient?.isGradientChecked}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </div>
                    </div>

                    {value?.gradient?.isGradientChecked && (
                      <div className="flex flex-col">
                        <GradientPicker
                          value={value?.gradient?.color}
                          onChange={e =>
                            onChange({
                              ...value,
                              gradient: { ...value?.gradient, color: e },
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                </WithAccordion>

                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="Hide Star Rating">
                        <span>Hide Title</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Switch
                    className="flex justify-between items-center mb-3"
                    checked={value?.hideTitle}
                    onChange={e => {
                      const selectedValue = e.target.checked;
                      onChange({
                        ...value,
                        hideTitle: selectedValue,
                      });
                    }}
                  />
                </FieldLabel>

                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="Hide Star Rating">
                        <span>Hide Offer</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Switch
                    className="flex justify-between items-center mb-3"
                    checked={value?.hideOffer}
                    onChange={e => {
                      const selectedValue = e.target.checked;
                      onChange({
                        ...value,
                        hideOffer: selectedValue,
                      });
                    }}
                  />
                </FieldLabel>
              </WithAccordion>
            </>
          );
        },
      },
    },
    defaultProps: {
      titleCustomization: {
        content:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">BEST DEAL</span></p>',
        bgColorTitle: { color: '#686868', isInherit: false },
        padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
      },
      offerCustomization: {
        content:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">GET 1 FOR</span></p>',
        bgColorOffer: { color: '#000000', isInherit: false },
        padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
      },
      CustamizeButton: {
        bgColor: { color: '#000000', isInherit: true },
        widthAndHeight: {
          height: {
            desktop: '100%',
            mobile: '100%',
            tablet: '100%',
          },
          maxWidth: {
            desktop: '100%',
            mobile: '100%',
            tablet: '100%',
          },
          deviceType: 'desktop',
          fullWidth: {
            desktop: false,
            mobile: false,
            tablet: false,
          },
        },
        gradient: {
          isGradientChecked: false,
          color:
            'linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(0,0,255,1) 100%)',
        },

        hideTitle: false,
        hideOffer: false,
      },
      margin: {
        deviceType: 'desktop',
        marginBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      showComponent: ['desktop', 'tablet', 'mobile'],

      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      ...borderProps,
    },
    render: ({
      offerCustomization,
      titleCustomization,
      margin,
      padding,
      border,
      CustamizeButton,
      showComponent,
      editMode,
    }) => {
      const dispatch = useAppDispatch();
      const { pathname } = useLocation();
      const navigate = useNavigate();
      const checkoutState = useAppSelector(state => state.checkout);
      const postUpsell = useAppSelector(state => state.postUpSell);
      const postUpsellState = useAppSelector(state => state.postUpSellState);
      const storeState = useAppSelector(state => state.store);
      const { cartData } = useAppSelector(state => state.cart);
      const isCheckoutPaymentPaypal = useAppSelector(
        state => state.common.isPaymentByPaypal,
      );
      // const upsellNavigationLoader = postUpsell.upsellNavigationLoader;
      const orderID = checkoutState.checkoutOrderID;
      const purchaseToken = checkoutState.purchaseToken;
      const postUpSellRecommendation = postUpsell.postUpsellData;
      const currentPageData = postUpsell.currentUpsellData;
      const upsellData = postUpsell.upsellData;
      const storeData = storeState.storeData;
      const IndependentTransactionForUpsellPages =
        storeData?.IndependentTransactionForUpsellPages ||
        isCheckoutPaymentPaypal ||
        false;
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getNewMarginStyles(margin, currentDeviceType);
      const currentRecommendation =
        postUpSellRecommendation?.[postUpsellState?.currentIndex];
      const [searchParams] = useSearchParams();
      const selectedUpsellItems = postUpsell.selectedUpsellItems;
      const selectedVariantForSingleProduct = useAppSelector(
        state => state.postUpSell.selectedVariantForSingleProduct,
      );
      const smartUpsellFunnelID = useAppSelector(
        state => state.postUpSell.smartUpsellFunnelID,
      );
      const IsViewIsEdit = getIsViewIsEdit();
      const isUpsellFunnelPreview = searchParams.get('isUpsellFunnelPreview');

      const newSearchParams = new URLSearchParams(searchParams.toString());
      const state = useAppSelector(state => state);
      const newInterpolation = getQuillEditorText(
        titleCustomization?.content,
        state,
      );
      const isPaymentPayPalCheckout = useAppSelector(
        state => state.common.isPaymentByPaypal,
      );

      let navStateForUpsell = {};
      if (
        !getIsViewIsEdit() &&
        upsellData?.[currentPageData?.accept?.nextProduct]?.pageId
      ) {
        navStateForUpsell = {
          state: upsellData?.[currentPageData?.accept?.nextProduct]?.pageId
            ? {
                id: upsellData?.[currentPageData?.accept?.nextProduct]?.pageId,
                pageVisiblity: '',
                pageType: PageType.UPSELL,
              }
            : {},
        };
      }

      const navigateFunctionForUpsell = useCallback(() => {
        if (upsellData?.['' + currentPageData?.accept?.nextProduct].pageId) {
          navigate(
            pathname + '?' + newSearchParams.toString(),
            navStateForUpsell,
          );
        }
      }, [upsellData?.[currentPageData?.accept?.nextProduct]?.pageId]);

      const openEditor = async () => {
        const newPageID =
          upsellData?.[currentPageData?.accept?.nextProduct]?.pageId;
        const updatedSearchParams = new URLSearchParams(
          searchParams.toString(),
        );
        updatedSearchParams.set('pageID', String(newPageID));
        navigate(pathname + '?' + updatedSearchParams.toString());
      };

      async function handleClick() {
        if (IsViewIsEdit && !!isUpsellFunnelPreview) {
          if (currentPageData?.accept?.nextProduct) {
            await openEditor();
            dispatch(
              setCurrentUpsellData(
                upsellData?.[currentPageData?.accept?.nextProduct],
              ),
            );
          } else if (!currentPageData?.decline?.nextProduct) {
            showNotification('success', 'Upsell flow ended here');
          }
        } else {
          dispatch(setIsLoading(true));

          const currentProductId = [
            {
              variantId: selectedVariantForSingleProduct?.value
                ? checkAndReturnWithProductVariantIdPrefix(
                    '' + selectedVariantForSingleProduct?.value,
                  )
                : checkAndReturnWithProductVariantIdPrefix(
                    '' +
                      currentPageData?.products?.[0]?.variants[0]
                        ?.productVariants?.value,
                  ),
              GroupId: currentPageData?.upsellgroup_id || '',
              IsDownsell: currentPageData?.isDownSell,
              DownsellId: currentPageData?.isDownSell
                ? currentPageData?.downsell_id
                : '',
              ProductId: currentPageData?.products?.[0]?.id || '',
            },
          ];
          const newSelectedItems = [
            ...selectedUpsellItems,
            ...currentProductId,
          ];
          dispatch(setSelectedUpsellItems(newSelectedItems));
          await new Promise(resolve => setTimeout(resolve, 1000));

          if (!currentPageData?.accept?.nextProduct) {
            try {
              IndependentTransactionForUpsellPages
                ? await handleCompletePurchase(currentProductId, true)
                : await handleCompletePurchase(newSelectedItems, true);
              dispatch(setIsLoading(false));
            } catch (error) {
              dispatch(setIsLoading(false));
            }
          } else {
            if (IndependentTransactionForUpsellPages)
              handleCompletePurchase(currentProductId, false);
            navigateFunctionForUpsell();
            dispatch(
              setCurrentUpsellData(
                upsellData?.[currentPageData?.accept?.nextProduct],
              ),
            );
            dispatch(setIsLoading(false));
          }
        }
      }

      async function handleClickPayPal() {
        if (currentPageData?.accept?.nextProduct) {
          navigateFunctionForUpsell();
          dispatch(
            setCurrentUpsellData(
              upsellData?.[currentPageData?.accept?.nextProduct],
            ),
          );
        }
      }

      let navStateThankYouPage = {};
      if (!getIsViewIsEdit() && checkoutState?.nextpageConfig?.id) {
        navStateThankYouPage = {
          state: checkoutState?.nextpageConfig?.id
            ? {
                id: checkoutState?.nextpageConfig?.id,
                pageVisiblity: checkoutState?.nextpageConfig?.pageVisiblity,
                pageType: checkoutState?.nextpageConfig?.pageType,
              }
            : {},
        };
      }

      const navigateFunctionToThankYouPage = useCallback(() => {
        if (checkoutState?.nextpageConfig?.id) {
          navigate(
            pathname + '?' + newSearchParams.toString(),
            navStateThankYouPage,
          );
        }
      }, [
        checkoutState.nextpageConfig?.id,
        checkoutState.nextpageConfig?.pageVisiblity,
      ]);

      // const newShopUrl = storeData?.ShopURL?.replace('https://', '');
      // const url = `/confirmation-page?store=${newShopUrl}`;
      const isNavToThankyouPage = !currentPageData?.accept?.nextProduct;
      const handleCompletePurchase = useCallback(
        async (
          selectedItems: ISelectedUpsellItems[],
          isNavToThankyouPage: boolean,
        ) => {
          if (isCheckoutPaymentPaypal) return;
          if (selectedItems.length === 0) {
            navigateFunctionToThankYouPage();
            return;
          }
          const payload: postUpsellPurchasePayload = {
            LineItems: selectedItems
              .filter(item => item)
              .map(item => ({
                Quantity: 1,
                VariantID: item.variantId,
                UpsellDetails: {
                  GroupId: item.GroupId,
                  IsDownsell: item.IsDownsell,
                  DownsellId: item.IsDownsell ? (item.DownsellId ?? '') : '',
                  ProductId: item.ProductId,
                },
              })),
            // OrderID: orderID,
            PurchaseToken: purchaseToken,
            ShopID: storeData?.ShopID,
            FunnelId: Number(smartUpsellFunnelID),
            StoreID: storeData?.StoreID || '',
          };
          try {
            const res = await checkoutService.postUpsellPurchase(payload);
            if (res.status === 200) {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionToThankYouPage();
            }
          } catch (error: unknown) {
            const err = error as ErrorResponse;
            if (err.status === 400) {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionToThankYouPage();
              dispatch(setErrorStatus(err.status));
              throw error;
            } else {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionToThankYouPage();
              throw error;
            }
          } finally {
            dispatch(setIsLoading(false));
          }
        },
        [
          navigate,
          navigateFunctionToThankYouPage,
          orderID,
          purchaseToken,
          storeData,
        ],
      );
      useEffect(() => {
        if (currentRecommendation?.Variants?.[0])
          dispatch(
            setSelectedVariant({
              ...currentRecommendation?.Variants?.[0],
              Quantity: 1,
            }),
          );
      }, [currentRecommendation]);
      const containerStyle: React.CSSProperties = {
        background: CustamizeButton.gradient?.isGradientChecked
          ? CustamizeButton.gradient?.color
          : CustamizeButton.bgColor?.isInherit
            ? 'inherit'
            : CustamizeButton.bgColor?.color,
      };

      const buttonSize: React.CSSProperties =
        currentDeviceType &&
        CustamizeButton?.widthAndHeight?.maxWidth &&
        CustamizeButton?.widthAndHeight?.height &&
        CustamizeButton?.widthAndHeight?.maxWidth[currentDeviceType] !==
          undefined &&
        CustamizeButton?.widthAndHeight?.height[currentDeviceType] !== undefined
          ? {
              width: CustamizeButton?.widthAndHeight?.fullWidth?.[
                currentDeviceType
              ]
                ? '100%'
                : isNaN(
                      +CustamizeButton?.widthAndHeight?.maxWidth[
                        currentDeviceType
                      ],
                    )
                  ? CustamizeButton?.widthAndHeight?.maxWidth[currentDeviceType]
                  : `${+CustamizeButton?.widthAndHeight?.maxWidth[currentDeviceType]}px`,

              height: isNaN(
                +CustamizeButton?.widthAndHeight?.height[currentDeviceType],
              )
                ? CustamizeButton?.widthAndHeight?.height[currentDeviceType]
                : `${+CustamizeButton?.widthAndHeight?.height[currentDeviceType]}px`,
            }
          : {};

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              style={{
                ...marginStyles,
                ...getPaddingStyles(padding, currentDeviceType),
                ...containerStyle,
              }}>
              {/* {postUpsellState.showPopup && (
                <div
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1000,
                  }}>
                  <UpSellPopUp
                    message={postUpsellState.popupMessage}
                    onDismiss={() => {
                      dispatch(setShowPopup(false));
                      navigateFunction();
                    }}
                  />
                </div>
              )} */}
              <div className={`flex flex-col `}>
                {!isCheckoutPaymentPaypal ? (
                  <PostUpSellDeal
                    border={border}
                    hideTitle={CustamizeButton?.hideTitle}
                    height={CustamizeButton?.widthAndHeight?.height}
                    maxWidth={CustamizeButton?.widthAndHeight?.maxWidth}
                    fullWidth={CustamizeButton?.widthAndHeight?.fullWidth}
                    currentDeviceType={currentDeviceType}
                    hideOffer={CustamizeButton?.hideOffer}
                    title={newInterpolation}
                    offer={offerCustomization?.content}
                    bgColorTitle={titleCustomization?.bgColorTitle}
                    bgColorOffer={offerCustomization?.bgColorOffer}
                    titlePadding={titleCustomization?.padding}
                    offerPadding={offerCustomization?.padding}
                    cartData={cartData}
                    selectedVariant={postUpsellState.selectedVariant}
                    currentRecommendation={currentRecommendation}
                    currentIndex={postUpsellState.currentIndex}
                    handleCompletePurchase={handleCompletePurchase}
                    handleClick={handleClick}
                    postUpSellRecommendation={postUpSellRecommendation}
                    selectedItems={postUpsellState.selectedItems}
                    isLoading={postUpsellState.isLoading}
                    currentUpsellData={currentPageData}
                    upsellData={upsellData}
                    selectedUpsellItems={selectedUpsellItems}
                    selectedVariantForSingleProduct={
                      selectedVariantForSingleProduct
                    }
                    IndependentTransactionForUpsellPages={
                      IndependentTransactionForUpsellPages
                    }
                    isPaymentPayPalCheckout={isPaymentPayPalCheckout}
                  />
                ) : (
                  <Suspense
                    fallback={
                      <button className="px-3 py-1.5 rounded-md bg-gray-400 text-white text-sm animate-pulse w-32 h-10" />
                    }>
                    <div style={{ width: buttonSize.width }}>
                      <PostUpsellPayPal
                        selectedItems={[
                          ...[
                            {
                              variantId: selectedVariantForSingleProduct?.value
                                ? checkAndReturnWithProductVariantIdPrefix(
                                    '' + selectedVariantForSingleProduct?.value,
                                  )
                                : checkAndReturnWithProductVariantIdPrefix(
                                    '' +
                                      currentPageData?.products?.[0]
                                        ?.variants[0]?.productVariants?.value,
                                  ),
                              GroupId: currentPageData?.upsellgroup_id || '',
                              IsDownsell: currentPageData?.isDownSell,
                              DownsellId: currentPageData?.isDownSell
                                ? currentPageData?.downsell_id
                                : '',
                              ProductId:
                                currentPageData?.products?.[0]?.id || '',
                            },
                          ],
                        ]}
                        purchaseToken={purchaseToken}
                        handleClick={handleClickPayPal}
                        buttonSize={buttonSize}
                        storeData={storeData}
                        navigateToConfirmationPage={
                          navigateFunctionToThankYouPage
                        }
                        smartUpsellFunnelID={smartUpsellFunnelID}
                        useAppDispatch={useAppDispatch}
                        isNavToThankyouPage={isNavToThankyouPage}
                      />
                    </div>
                  </Suspense>
                )}
              </div>
            </div>
          )}
        </>
      );
    },
  };
};
